
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller/register",
      function () {
        return require("private-next-pages/seller/register/index.js");
      }
    ]);
  